import { gql } from '@apollo/client';

export const GET_CAMPAIGNS = gql(/* GraphQL */ `
  query GetCampaigns {
    campaigns {
      campaignId
      merchantId
      name
      type
      status
      createdBy
      createdAt
      updatedAt
      scheduled
      generatedAt
      metadata
      metrics {
        opened
        sent
        clicked
        ordered
        earned
      }
      segments {
        include
        exclude
      }
      variants {
        variantId
        campaignId
        channel
        variantName
        splitWeight
        content
        metadata
        createdAt
        updatedAt
      }
    }
  }
`);

export const GET_CAMPAIGN = gql(/* GraphQL */ `
  query GetCampaign($id: ID!) {
    campaign(id: $id) {
      campaignId
      merchantId
      name
      type
      status
      createdBy
      createdAt
      updatedAt
      scheduled
      generatedAt
      metadata
      metrics {
        opened
        sent
        clicked
        ordered
        earned
      }
      segments {
        include
        exclude
      }
      variants {
        variantId
        campaignId
        channel
        variantName
        splitWeight
        content
        metadata
        createdAt
        updatedAt
      }
    }
  }
`);
